<div class="container content">
  <div class="center-element">
    <div class="col-md-12">
      <img src="/assets/logo-posso-agendar-borda-azul-desktop.svg" alt="Posso Agendar?" class="login-img hidden-xs" />
      <img src="/assets/logo-posso-agendar-borda-azul.svg" alt="Posso Agendar?" class="login-img visible-xs" />
      <h2 class="subtitle">Olá, bem vindo a plataforma que cuida da sua saúde!</h2>
      <mat-card>
        <form [formGroup]="form" class="example-form">
          <page-alert message="Usuário logado com sucesso!" *ngIf="successLogin && submitted" alertClass="alert-success"></page-alert>
          <page-alert message="Falha ao logar usuário!" *ngIf="!successLogin && submitted" alertClass="alert-danger"></page-alert>

          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>E-mail</mat-label>
            <input type="email" matInput formControlName="email" placeholder="Email" />

            <mat-error *ngIf="form.get('email')?.hasError('email')"> - Insira um email válido. </mat-error>
          </mat-form-field>

          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Senha</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" />
            <button type="button" class="icon-button" mat-icon-button matSuffix (click)="hide = !hide">
              <mat-icon matSuffix>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>

            <mat-error *ngIf="form.get('password')?.hasError('required')"> - Insira uma senha válida. </mat-error>
          </mat-form-field>

          <button class="btn-login" mat-flat-button color="primary" (click)="login()" [disabled]="loading">Entrar</button>
        </form>

        <div class="social-login">
          <p>Entrar com outro método:</p>
          <div class="social-buttons">
            <button mat-stroked-button color="primary" (click)="loginWithGoogle()" class="google"><i class="icon-google"></i> Google</button>
            <button mat-flat-button color="primary" (click)="loginWithFacebook()" class="facebook"><i class="fab fa-facebook"></i> Facebook</button>
            <button mat-flat-button color="primary" (click)="loginWithApple()" class="apple"><i class="fab fa-apple"></i>Apple</button>
          </div>
        </div>

        <button class="btn-esqueci esqueci-senha-btn" mat-stroked-button color="warn" (click)="recuperarSenha()">Esqueci minha senha</button>

        <div class="criar-conta">
          Ainda não tem conta? <button (click)="newRegistration()" mat-flat-button color="primary" class="btn-criar">Criar conta</button>
        </div>
      </mat-card>
    </div>
  </div>
</div>
